import React from "react";
import GenericButton from "../../common/genericButton";
import GenericInput from "../../common/GenericInput";
import GenericModal from "../../common/genericModal";
import styles from "./SendBtc.module.scss";
import { Link } from "react-router-dom";

const SendBTC = ({ isOpen, toggle }) => {
  const changeHandler = () => {};
  return (
    <>
      <GenericModal isOpen={isOpen} toggle={toggle}>
        <div className={styles.img}>
          <img src="/assets/bitcoin-logo.png" alt="bit-coin" />
        </div>
        <div className={styles.mainheading}>Send BTC</div>

        <div className={styles.fieldWrapper}>
          <GenericInput
            label={"Send To"}
            placeholder="Enter Bitcoin address "
            type="text"
            withRightIcon={"/assets/copy.png"}
            name="email"
            onChange={changeHandler}
            icon={false}
          />
        </div>

        <div className={styles.text}>Auto Amount</div>
        <div className={styles.buttonsdiv}>
          <div className={styles.buttonWrapper}>
            <GenericButton title="MAX" />
          </div>
          <div className={styles.buttonWrapper}>
            <GenericButton title="HALF" />
          </div>
          <div className={styles.buttonWrapper}>
            <GenericButton title="MIN" />
          </div>

          {/* <div className={styles.button}>Max</div>
          <div className={styles.button2}>Half</div>
          <div className={styles.button2}>Min</div> */}
        </div>

        <div className={styles.fieldWrapper}>
          <GenericInput
            label={"BTC"}
            placeholder="Enter amount in BTC"
            type="text"
            withRightIcon={false}
            name="email"
            onChange={changeHandler}
          />
          <GenericInput
            label={"Amount"}
            placeholder="€  0.00"
            type="text"
            withRightIcon={false}
            name="email"
            onChange={changeHandler}
          />
        </div>

        <div className={styles.fieldWrapper}>
          <div className={styles.footerdiv}>
            <div className={styles.row1}>
              <div className={styles.lefttext}>Transaction Fee:</div>
              <div className={styles.righttext}>
                <div className={styles.amount1}>0.00 &nbsp;&nbsp; BTC</div>
                <div className={styles.amount2}>0.00 &nbsp;&nbsp; USD</div>
              </div>
            </div>
            <div className={styles.row2}>
              <div className={styles.lefttext}>Estimated Balance:</div>
              <div className={styles.righttext}>
                <div className={styles.amount1}>0.00 &nbsp;&nbsp; BTC</div>
                <div className={styles.amount2}>0.00 &nbsp;&nbsp; USD</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <GenericButton title={"Send"} icon={"/assets/arrowup.png"}/>
        </div>
      </GenericModal>
    </>
  );
};

export default SendBTC;
